import { render, staticRenderFns } from "./AccountFlowTable.vue?vue&type=template&id=1c78c51e&scoped=true"
import script from "./AccountFlowTable.vue?vue&type=script&lang=js"
export * from "./AccountFlowTable.vue?vue&type=script&lang=js"
import style0 from "./AccountFlowTable.vue?vue&type=style&index=0&id=1c78c51e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c78c51e",
  null
  
)

export default component.exports